import * as React from 'react';
import { Calendar, momentLocalizer, View, stringOrDate } from 'react-big-calendar'
import moment from 'moment'
import "./react-big-calendar.css";
import { Grid, Typography, CircularProgress } from '@material-ui/core';
import Paper from '../Containers/Paper';
import { Star } from '@material-ui/icons';
import { ActivityState } from '../../model/activities';

const localizer = momentLocalizer(moment)

export type CalendarEvent = {
    title: string,
    start: Date,
    end: Date,
    allDay?: boolean
    resource?: any,
    color?: string,
}
export const emptyEvent: CalendarEvent = {
    title: '',
    start: new Date(),
    end: new Date(),
    resource: {
        isReservable: true,
        date: new Date(),
        displayName: '',
        description: '',
        duration: 60,
        capacity: 10,
        trainerIds: [],
        state: ActivityState.approved
    },
}
interface IProps {
    title: string;
    events: CalendarEvent[];
    views?: View[]
    defaultView: View;
    renderDetail: (e: CalendarEvent) => JSX.Element;
    renderEmptyDetail?: () => JSX.Element;
    onRangeChange?: (start: stringOrDate, end: stringOrDate) => void;
    selectedEvent?: CalendarEvent;
    loading?: boolean;
    height?: number;
    onEventSelected?: (e: CalendarEvent) => void;
}

const EventComp = (props: { event: CalendarEvent }) => {
    const sched = props.event.resource;
    if (!sched?.isReservable) {
        return <div className="rbc-event-content"
            style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-around' }}>
            <div>
                <Star style={{ fontSize: 12, color: sched?.tag?.color ? `${sched?.tag?.color}` : 'white' }}/>
                <span>{props.event.title}</span>
            </div>
        </div>
    }
    else {
        let w = (sched.reservations?.length || 0) / sched.capacity * 100;
        const color = sched?.tag?.color ? `${sched?.tag?.color}` : '#000000';
        return <div className="rbc-event-content"
            style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-around' }}>
            <div>
                <span>{props.event.title}</span>
            </div>
            <div style={{ marginLeft: 3, width: '100%', height: 5, display: 'flex' }}>
                <div style={{ minWidth: 5, width: `${w}%`, height: 5, backgroundColor: color }}></div>
                <div style={{ width: `calc(100% - ${w}%`, height: 5, backgroundColor: '#a29f9f' }}></div>
            </div>
        </div>
    }
}
let components = {
    event: EventComp, // used by each view (Month, Day, Week)
}
export const BigCalendar = (props: IProps) => {
    const [currentEventComponent, setCurrentEventComponent] = React.useState<JSX.Element>();
    const [emptyEventComponent, setEmptyEventComponent] = React.useState<JSX.Element>(<Typography>Seleziona un evento per i dettagli</Typography>);
    const [currentEvent, setCurrentEvent] = React.useState<CalendarEvent>();
    const [detailSelected, setDetailSelected] = React.useState(false);
    // eslint-disable-next-line
    const [currentView, setCurrentView] = React.useState<View>(props.defaultView);
    const [controlledSelectedEvent, setControlledSelectedEvent] = React.useState<CalendarEvent>();

    React.useEffect(() => {
        setControlledSelectedEvent(props.selectedEvent);
    }, [props.selectedEvent])

    React.useEffect(() => {
        if (props.renderEmptyDetail)
            setEmptyEventComponent(props.renderEmptyDetail());
            // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.renderEmptyDetail]);

    React.useEffect(() => {
        if (controlledSelectedEvent && (!currentEvent || props.selectedEvent.resource._id !== currentEvent.resource._id)) {
            const newEvent = props.events.find(a => a.resource?._id === props.selectedEvent.resource?._id);
            if (newEvent) {
                const Comp = props.renderDetail(newEvent);
                setCurrentEventComponent(Comp);
                setCurrentEvent(newEvent);
                setDetailSelected(true);
            }
            else {
                setDetailSelected(false);
            }
        }
        else setDetailSelected(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [controlledSelectedEvent]);
    React.useEffect(() => {
        if (currentEvent && !controlledSelectedEvent) {
            const newEvent = props.events.find(a => a.resource?._id === currentEvent.resource?._id);
            if (newEvent) {
                const Comp = props.renderDetail(newEvent);
                setCurrentEventComponent(Comp);
                setCurrentEvent(newEvent);
                setDetailSelected(true);
            }
            else {
                setDetailSelected(false);
            }
        }
        else setDetailSelected(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.events]);
    const selectEventItem = (e: CalendarEvent) => {
        const Comp = props.renderDetail(e);
        setCurrentEventComponent(Comp);
        setCurrentEvent(e);
        setDetailSelected(true);
        setControlledSelectedEvent(undefined);
    }
    const selectEmptySlot = (slotInfo: { start: stringOrDate; end: stringOrDate; slots: string[] | Date[]; action: "select" | "click" | "doubleClick"; }) => {
        setDetailSelected(false);
    }
    const eventStyleGetter = (event: CalendarEvent, start: stringOrDate, end: stringOrDate, isSelected: boolean) => {
        //console.log(event);
        var style: any = {}
        if (detailSelected && currentEvent && currentEvent.resource._id === event.resource._id) {
            style.color = "#333";
            style.backgroundColor = '#fcdbbb';
            style.border = "2px solid #393f55";
            style.fontWeight = 'italic'
        }
        return {
            style: style
        };
    }
    const onRangeChange = (range: any) => {
        if (range.length) {
            if (range.length === 1) {
                const r = range[0] as Date;
                const from = new Date(r.getFullYear(), r.getMonth(), r.getDate());
                const to = new Date(r.getFullYear(), r.getMonth(), r.getDate(), 23, 59, 59);
                props.onRangeChange(from, to);
            }
            else if (range.length > 1) {
                const from = range[0];
                const to = range[range.length - 1];
                props.onRangeChange(from, to);
            }
        } else if (range.start && range.end)
            props.onRangeChange(range.start, range.end)
        setDetailSelected(false);
        setCurrentEvent(undefined);
        setControlledSelectedEvent(undefined);
    }


    return <Grid container style={{ padding: 20 }} sm={12}>
        <Grid item sm={8} style={{ padding: 5 }}>
            <Paper title={props.title} fullHeight>
                <Calendar
                    popup
                    components={components}
                    eventPropGetter={eventStyleGetter}
                    onView={setCurrentView}
                    onRangeChange={onRangeChange}
                    localizer={localizer}
                    events={props.events}
                    views={props.views}
                    startAccessor="start"
                    min={new Date(2020, 10, 0, 6, 0, 0)}
                    max={new Date(2020, 10, 0, 22, 0, 0)}
                    endAccessor="end"
                    defaultView={props.defaultView}
                    style={{ height: props.height }}
                    selectable
                    onSelectEvent={selectEventItem}
                    onSelectSlot={selectEmptySlot}
                    messages={{
                        month: 'Mese',
                        day: 'Giorno',
                        today: 'Oggi',
                        date: 'Date',
                        time: 'Ora',
                        event: 'Evento',
                        allDay: 'Tutto il giorno',
                        week: 'Settimana',
                        work_week: 'Settimana lavorativa',
                        previous: 'Indietro',
                        next: 'Avanti',
                        yesterday: 'Ieri',
                        tomorrow: 'Domani',
                        agenda: 'Agenda',
                        noEventsInRange: 'Non ci sono eventi in questo periodo',

                        showMore: total => `+${total}...`,
                    }}
                />
                {props.loading && <div style={{ position: 'absolute', top: 0, left: 0, height: '100%', width: '100%', backgroundColor: '#cecfd080', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <CircularProgress style={{ top: 'calc(50% - 60px)', left: 'calc(50% - 60px)' }} size={120} />
                </div>}
            </Paper>
        </Grid>
        <Grid item sm={4} style={{ padding: 5 }}>
            <Paper fullHeight title={detailSelected ? currentEvent.title : 'Eventi nel periodo'}>
                <Grid container sm={12}>
                    {!detailSelected && <Grid item sm={12}>
                        {emptyEventComponent}
                    </Grid>}
                    {detailSelected && <Grid item sm={12}>
                        {Boolean(currentEvent && currentEventComponent) ? currentEventComponent : null}
                    </Grid>}
                </Grid>
            </Paper>
        </Grid>
        {/* <Dialog maxWidth={'lg'} open={showDetail} onClose={() => setShowDetail(false)}>
            {currentEventComponent}
        </Dialog> */}
    </Grid>
}